import axios from 'axios'
import { useUserStore } from '@/store/user'

const BASE_URL = process.env.VUE_APP_API_URL

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 16000,
  withCredentials: true
});

instance.interceptors.response.use(function (response) {
  return response;
}, function (error) {

  if (!error.response) { // network error, timeout or canceled request: no HTTP response to inspect
    console.log(error, ' error ');
    return Promise.reject(error);
  }

  if (error.response.status === 402) { // "payment is needed"
    const errorData = error.response.data ? error.response.data : {}
    const checkForMFA = errorData.error = 'checkForMFA'
    if (checkForMFA) {
      // TODO is this needed (reset user store)??
      // const userStore = useUserStore()
      // userStore.reset() // avoid reusing other clinic info
      window.location = `/auth/mfa?data=${errorData.data}`
      return
    }
  }

  if (error.response.status === 403) {
    const errorData = error.response.data || {}
    if (errorData.message === 'forbidden') {
      window.location = "/denied"
      return
    }
    const userStore = useUserStore()
    userStore.reset() // avoid reusing other clinic info
    // EC-517 avoid login loop
    window.location = "/auth/expired"
    return
  }

  if (error.response.status === 503) {
    window.location = "/maintenance"
  }
  console.log(error, ' error ');
  return Promise.reject(error);
});

// Axios clean for requests outside of EyerCloud
const externalInstance = axios.create({
  timeout: 60000,
  withCredentials: false
});

export default {
  ...instance,
  external: externalInstance
}
